import { create } from 'zustand';
import { v4 as uuidv4 } from 'uuid';

type State = {
  sessionId: string;
  pdfUrl: string;
  skipCalculator: boolean;
  tocAccepted: boolean;

  userHeatingDemand: number;
  userHeatingPowerDemand: number;
  userEnergyConsumption: number;

  acceptedCookieCategories: string[];
};

type Actions = {
  setSessionId: (sessionId: string) => void;
  setPdfUrl: (pdfUrl: string) => void;
  setSkipCalculator: (skipContactForm: boolean) => void;
  setTocAccepted: (tocAccepted: boolean) => void;

  setUserHeatingDemand: (userHeatingDemand: number) => void;
  setUserHeatingPowerDemand: (userHeatingPowerDemand: number) => void;
  setUserEnergyConsumption: (userEnergyConsumption: number) => void;

  resetSessionStore: () => void;

  setAcceptedCookieCategories: (cats: string[]) => void;
};

const initialState: State = {
  sessionId: uuidv4(),
  pdfUrl: '',
  skipCalculator: false,
  tocAccepted: false,

  userHeatingDemand: 0,
  userHeatingPowerDemand: 0,
  userEnergyConsumption: 0,

  acceptedCookieCategories: [],
};

export const useSessionStore = create<State & Actions>((set) => ({
  ...initialState,
  setSessionId: (sessionId) => set({ sessionId }),
  setPdfUrl: (pdfUrl) => set({ pdfUrl }),
  setSkipCalculator: (skipCalculator) => set({ skipCalculator }),
  setTocAccepted: (tocAccepted) => set({ tocAccepted }),

  setUserHeatingDemand: (userHeatingDemand) => set({ userHeatingDemand }),
  setUserHeatingPowerDemand: (userHeatingPowerDemand) => set({ userHeatingPowerDemand }),
  setUserEnergyConsumption: (userEnergyConsumption) => set({ userEnergyConsumption }),

  resetSessionStore: () => set(initialState),

  setAcceptedCookieCategories: (cats) => set({ acceptedCookieCategories: cats }),
}));
